import React from 'react';
import Navbar from './global-components/navbar-v2';
import PageHeader from './global-components/page-header';
import CallToActionV1 from './section-components/call-to-action-v1';
import Footer from './global-components/footer';
import TopBar from './global-components/topbar';
import ConstructionInfo from './section-components/construction-info';

const Construction = () => {
    return <div>
        <TopBar/>
        <Navbar />
        <PageHeader headertitle="House Construction" subheader="Construction" />
        <ConstructionInfo />
        <CallToActionV1 />
        <Footer />
    </div>
}

export default Construction
